<template>
  <md-table v-model="sites" class="table-striped" table-header-color="primary">
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        {{ item.name }}
      </md-table-cell>
      <md-table-cell class="text-right">
        <md-button class="md-just-icon md-primary" @click="viewItem(item.id)">
          <md-tooltip>View Site</md-tooltip>
          <md-icon>forward</md-icon>
        </md-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Sites Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      sites: "portfolio/sites"
    })
  },
  methods: {
    viewItem(id) {
      this.$router.push({
        name: "Site Details",
        params: { siteId: id }
      });
    }
  }
};
</script>

<style></style>
